import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const Pagination = ({
  currentPage,
  totalItems,
  totalPages: propTotalPages,
  itemsPerPage = 10,
  onPageChange,
  className = "",
  showWhenSinglePage = false,
}) => {
  const totalPages = propTotalPages || Math.ceil(totalItems / itemsPerPage);

  if (!showWhenSinglePage && totalPages <= 1) return null;

  const getVisiblePages = () => {
    const delta = 2;
    const range = [];
    const rangeWithDots = [];

    for (
      let i = Math.max(2, currentPage - delta);
      i <= Math.min(totalPages - 1, currentPage + delta);
      i++
    ) {
      range.push(i);
    }

    if (currentPage - delta > 2) {
      rangeWithDots.push(1, '...');
    } else {
      rangeWithDots.push(1);
    }

    rangeWithDots.push(...range);

    if (currentPage + delta < totalPages - 1) {
      rangeWithDots.push('...', totalPages);
    } else {
      rangeWithDots.push(totalPages);
    }

    return rangeWithDots;
  };

  const visiblePages = getVisiblePages();

  return (
    <div className={`flex items-center justify-between mt-6 ${className}`}>
      {/* Items info */}
      <div className="text-sm text-gray-700">
        Showing {Math.min((currentPage - 1) * itemsPerPage + 1, totalItems)} to{' '}
        {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems} entries
      </div>

      {/* Pagination controls */}
      <div className="flex items-center space-x-1">
        {/* Previous button */}
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`
            px-3 py-1 rounded-md border text-sm font-medium transition-colors
            ${currentPage === 1
              ? 'bg-gray-100 text-gray-400 border-gray-300 cursor-not-allowed'
              : 'bg-white text-gray-500 border-gray-300 hover:bg-gray-50 hover:text-gray-700'
            }
          `}
        >
          <FaChevronLeft className="w-3 h-3" />
        </button>

        {/* Page numbers */}
        {visiblePages.map((page, index) => (
          <button
            key={index}
            onClick={() => typeof page === 'number' ? onPageChange(page) : null}
            disabled={page === '...'}
            className={`
              px-3 py-1 rounded-md border text-sm font-medium transition-colors
              ${page === currentPage
                ? 'bg-blue-600 text-white border-blue-600'
                : page === '...'
                ? 'bg-white text-gray-400 border-gray-300 cursor-default'
                : 'bg-white text-gray-500 border-gray-300 hover:bg-gray-50 hover:text-gray-700'
              }
            `}
          >
            {page}
          </button>
        ))}

        {/* Next button */}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`
            px-3 py-1 rounded-md border text-sm font-medium transition-colors
            ${currentPage === totalPages
              ? 'bg-gray-100 text-gray-400 border-gray-300 cursor-not-allowed'
              : 'bg-white text-gray-500 border-gray-300 hover:bg-gray-50 hover:text-gray-700'
            }
          `}
        >
          <FaChevronRight className="w-3 h-3" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
